<script setup lang="ts">
import { AppText } from '@shared/ui/typography'

import { useDisciplineStore } from '../model/store'
import { useLessonEditStore } from '../model/lessons/edit/store'
import DisciplinePageLoader from './DisciplinePageLoader.vue'
import LessonConnectionLog from './lessons/LessonConnectionLog.vue'

defineOptions({
  name: 'LessonConnectionLogPage',
})

const disciplineStore = useDisciplineStore()
const lessonEditStore = useLessonEditStore()
</script>

<template>
  <DisciplinePageLoader :loading="lessonEditStore.isLoading" />
  <LessonConnectionLog
    v-if="lessonEditStore.getLesson && disciplineStore.getDiscipline"
  />
  <AppText
    v-else-if="!lessonEditStore.isLoading && !lessonEditStore.getLesson"
    name="body1"
    color="slate-500"
  >
    The lesson is not found in this discipline.
  </AppText>
</template>
